import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { PojavniOblik } from '@app/shared/models/pojavni-oblik';
import {
  Item,
  ListView,
  ListViewProviderDirective,
  UIComponents
} from '@ntap/core';
import { first, map, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-odaberi-pojavni-dostava',
  templateUrl: './odabir-pojavnog-dostava.html'
})
export class SelectPojavniDostavaComponent implements OnInit, AfterViewInit {
  @Output()
  itemSelected = new EventEmitter<PojavniOblik[]>();

  @ViewChild(ListViewProviderDirective)
  listViewProvider: ListViewProviderDirective<ListView>;

  INIT_COMP_ID = UIComponents.LISTVIEW;
  currentViewName: string;
  currentViewState: object | null = null;
  currentViewStateFilter: object = {};
  currentViewClass: string;

  disabled$: Observable<boolean>;

  private selectedItems$: Observable<Item[] | null>;

  ngOnInit(): void {
    this.currentViewName = 'pojavni_oblici_pretraga';
    this.currentViewState = {};
    this.currentViewStateFilter = {};
  }

  public ngAfterViewInit(): void {
    this.selectedItems$ = this.listViewProvider.selectedItems$;
    this.disabled$ = this.selectedItems$.pipe(map((i) => !i || i.length == 0));
  }

  public selectItem() {
    this.selectedItems$
      .pipe(
        first(),
        tap((items) => {
          if (!!items && items.length > 0) {
            this.itemSelected.next(items as PojavniOblik[]);
          }
        })
      )
      .subscribe();
  }
}
